import {
  FETCH_USER_DATA_BEGIN,
  FETCH_USER_DATA_ERROR,
  FETCH_USER_DATA_SUCCESS,
  LOGIN_BEGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT_BEGIN,
  LOGOUT_ERROR,
  LOGOUT_SUCCESS,
  PUSH_REDIRECT,
  SET_USER_DATA,
  SSO_LINK_BEGIN,
  SSO_LOGIN_BEGIN,
} from "./constants";

export function loginBegin(payload) {
  return {
    type: LOGIN_BEGIN,
    payload,
  };
}

export function ssoLinkBegin(payload) {
  return {
    type: SSO_LINK_BEGIN,
    payload,
  };
}

export function ssoLoginBegin(payload) {
  return {
    type: SSO_LOGIN_BEGIN,
    payload,
  };
}

// Action for *after* user has been authenticated
export function loginSuccess(token) {
  return {
    type: LOGIN_SUCCESS,
    token,
  };
}

export function loginError(error) {
  return {
    type: LOGIN_ERROR,
    error,
  };
}

export function logoutBegin() {
  return {
    type: LOGOUT_BEGIN,
  };
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

export function logoutError(error) {
  return {
    type: LOGOUT_ERROR,
    error,
  };
}

export function fetchUserDataBegin() {
  return {
    type: FETCH_USER_DATA_BEGIN,
  };
}

export function fetchUserDataSuccess() {
  return {
    type: FETCH_USER_DATA_SUCCESS,
  };
}

export function fetchUserDataError(error) {
  return {
    type: FETCH_USER_DATA_ERROR,
    error,
  };
}

export function setUserData(payload, append = false) {
  return {
    type: SET_USER_DATA,
    payload,
    append,
  };
}

export function pushRedirect(path) {
  return {
    type: PUSH_REDIRECT,
    path,
  };
}
